import { merge } from '../helper';

import { isEmpty } from '../general/isEmpty';
import isEmptyObject from '../general/isEmpty/isEmptyObject';
import prependChild from '../general/prepend/prependChild';
import setAttr from '../general/attr/setAttr';

import * as exElement from './element';
import * as exIcon from './icon';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (link)
    const elLink = exElement.create({
        merge: defConfig,
        tag: 'a',
    });
    elements.element = elLink;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using href
    if (config.href != null) {
        setAttr(elements.element, 'href', config.href);
    }

    // If using target
    if (config.target != null) {
        setAttr(elements.element, 'target', config.target);
    }

    // ------------------------------------------------------------------------

    // If using title
    if (config.title != null) {
        // If title is string or function
        if (typeof typeof config.title === 'string' || config.title === 'function') {
            config.title = {
                html: config.title,
            };
        }

        // Create element (title)
        const elTitle = exElement.create({
            merge: config.title,
            tag: 'span',
        });
        elements.element.appendChild(elTitle);
        elements.title = elTitle;
    }

    // If using icon
    if (!isEmptyObject(config.icon) || !isEmpty(config.icon)) {
        // Create element (icon)
        const elIcon = exIcon.create({
            merge: config.icon,
        });
        elements.icon = elIcon;

        // If using icon right
        if (config.icon.right === true) {
            elements.element.appendChild(elIcon);
        }
        // If using icon left
        else {
            prependChild(elements.element, elIcon);
        }
    }
}

// ----------------------------------------------------------------------------

export { create };
